import { Container, Text } from '@weareconceptstudio/core';

//* Styles
import HeroStyle from './style';

//* Lottie Files
import recipesHero from '@/lottie/recipesHero.json';

//* Components
import StyledQuotedText from '@/components/StyledQuotedText';
import LottieAnimation from '@/components/LottieAnimation';
import TitleAnim from '@/modules/_animation/Title';

const Hero = ({ title, description }) => {
	return (
		<HeroStyle>
			<Container row>
				<div className='empty-col col-3 col-dx-2 col-m-12' />

				<div className='hero-top-wrapper col-6 col-dx-8 col-m-12'>
					<div className='hero-top-inner-wrapper align-center'>
						<div className='hero-svg-block'>
							<LottieAnimation
								delay={100}
								autoplay={false}
								isPlay={true}
								isReverse={false}
								loop={false}
								animData={recipesHero}
							/>
						</div>
						<div className='wrapper-title'>
							<TitleAnim load={true}>
								<StyledQuotedText text={title} />
							</TitleAnim>
						</div>

						<Text className='p1 font-fss-light green-1000 hero-description'>{description}</Text>
					</div>
				</div>

				<div className='empty-col col-3 col-dx-2 col-m-12' />
			</Container>
		</HeroStyle>
	);
};

export default Hero;
